import Vue from 'vue'
import App from './App.vue'
import router from './router/index';

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

import Filter from './core/filters/index'
Vue.prototype.$F = Filter;
Object.keys(Filter).forEach(filterName => {
    Vue.filter(filterName, Filter[filterName])
})

import * as Util from './core/js/utils'
Vue.prototype.$U = {...Util, ...Filter};
Vue.prototype.$auth = Util.auth

import i18n from './core/i18n/index'
import ElementUI from 'element-ui';
Vue.use(ElementUI,{
    i18n: (key, value) => i18n.t(key, value)
});

import 'element-ui/lib/theme-chalk/icon.css';

import '@/assets/styles/base.css';
import '@/assets/iconfont/iconfont.css';
import '@/assets/styles/theme.scss';
import '@/assets/styles/public.scss';

Vue.config.productionTip = false;

new Vue({
    i18n,
    router,
    render: h => h(App)
}).$mount('#app')
